import React from 'react';
import Team from './Team';


const style = {
	aboutUsHeader: {
		fontSize: 36,
		fontWeight: 400,
		textAlign: 'center'
	},
	parentDiv: {
		paddingTop: 40,
		fontSize: 20,
	},
	card: {
		textAlign: 'center',
		margin: 25,
	},
	imgStyle: {
		paddingTop: 10,
		height: '230px',
		width: 'auto'
	},
};

const AboutUs = () => (
	<div>
		<section className="hero-area">
			<div className="container">
				<div className="row justify-content-center align-items-center">
					<div className="col-lg-6 order-lg-1">
						<div className="hero-image">
							<img src="images/ascend_about.jpg"/>
						</div>
					</div>
					<div className="col-lg-6 order-lg-2">
						<div className="hero-content">
							<h1>Mission</h1>
							<p>At Ascend Capital, we are on a mission to revolutionize India's mobility finance industry. Through a strong dedication to sustainability, technological advancements, and accessibility, we aim to become the forefront player in EV finance. Our unwavering commitment to our core values fuels our efforts to create a greener future and empower individuals to embrace the potential of electric vehicles. Join us in shaping a sustainable tomorrow through our innovative financing solutions.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div className="row about-us">
			<div className="container">
				<h3>The Company</h3>
				<div className="about-us-content">
					<p>Welcome to Ascend Capital, a pioneering RBI registered NBFC revolutionizing the EV financing landscape in India. Since 2018, we have specialized in providing financial inclusion for the underserved population in tier 2 and 3 cities. Our focus lies in offering tailored loans to cater to the unique needs of customers looking to purchase new commercial electric vehicles. With a team of exceptional individuals, including founders and core team from prestigious institutions like IIT Madras, IIT Kanpur, IIT Bombay, and IIM Calcutta, we are dedicated to our mission of empowering the bottom of the pyramid demographic. Currently operational in Rajasthan, UP, MP, Bihar and Delhi NCR, we are committed to driving sustainable change and accelerating the adoption of electric vehicles.</p>
				</div>
			</div>
		</div>
		<div className="row about-us">
			<div className="container">
				<h3>Our Core Values</h3>
				<div className="about-us-content">
				<p><strong>Innovation - </strong>
					We value above all our ability to serve our clients by constantly adapting services so that client needs are effectively met in a constantly changing economic environment. We trust our team's capability in evaluating genuine business needs of various industries such that customers get funds when they need them the most.</p>
					<p><strong>Integrity - </strong>
						We are committed to the highest standards of ethics, honesty and mutual respect in our internal and external relationships. Our customer's and stakeholders trust is of utmost importance to us so we believe in 100% transparent processes and policies.</p>
					<p><strong>Quality and Excellence - </strong>
						We strive for superior performance in our communications, standards, processes, leadership, planning, programming and execution.</p>
					<p><strong>Accountability - </strong>
						We are committed to doing what we say will do so our various stakeholders are confident that we are a trustworthy organisation making a positive economic impact in the lives of SMEs/MSMEs/Individual Customers.</p>
					<p><strong>Customer first - </strong>
						We are customer centric and believe in efficient processes to ensure their comfort. We respect their financial requirement and try to deliver lightning fast, customized and flexible terms funds with world class customer service.</p>
					<p><strong>Security - </strong>
						Customer's data is valuable and we follow best data security practices. All data exchanges happen behind SSL layer and saved in encrypted form.</p>
			</div>
			</div>
		</div>
		{<Team/>}
	</div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/AboutUs.js